<!--
 * @Description: 
 * @Author: knx-xc
 * @LastEditTime: 2020-09-01 14:26:12
 * @LastEditors: knx-xc
--> 
<template>
  <div class="home-body">
    <div class="home container-body">
      <div class="home-left">
        <div class="title">
          <ul>
            <li :class=" activeName == item.name ? 'active':''" @click="activeName = item.name" v-for="(item,index) of tabsContent" :key="index">
              <p class="name" v-text="item.label"></p>
              <div class="line">
                <span class="left"></span>
                <span class="center"><b></b></span>
                <span class="right"></span>
              </div>
            </li>
          </ul>
        </div>
        <div class="tabs">
          <div class="tab-content animated  " :class="index ==  0 ? 'fadeInLeft' : 'fadeInRight'" v-show="activeName == item.name " v-for="(item,index) of tabsContent " :key="index">
            <img :src="item.qr" alt="">
            <div class="info">
              <h1 v-text="item.title"></h1>
              <div>
                <p v-text="el" v-for="el in item.detail" :key="el"></p>
              </div>
              <router-link :to="{path:item.path}">
                <span v-text="'了解更多'"></span>
              </router-link>
            </div>
          </div>
        </div>

        <!-- 友情链接 -->
     <!--    <div class="friendly-link">
          <div class="friendly-title">
            <ul>
              <li class=" active">
                <p class="name" v-text="'合作伙伴'"></p>
                <div class="line">
                  <span class="left"></span>
                  <span class="center"><b></b></span>
                  <span class="right"></span>
                </div>
              </li>
            </ul>
          </div>
          <div class="friendly-content">
            <ul>
              <li v-show="activeName == 'first'" v-for="el of partner_t" :key="el.id">
                <a :href="el.url" target="_blank">
                  <img :src="el.img" alt="">
                </a>
              </li>
              <li v-show=" activeName == 'second' " v-for="el of partner_9" :key="el.id">
                <a :href="el.url" target="_blank">
                  <img :src="el.img" alt="">
                </a>
              </li>
              <li class="block"></li>
              <li class="block"></li>
              <li class="block"></li>
              <li class="block"></li>
              <li class="block"></li>
            </ul>
          </div>
        </div> -->

      </div>
      <div class="home-right">
        <div class="banner">
          <el-carousel indicator-position="outside"  >
            <el-carousel-item v-for="item in carousel" :key="item.title">
              <img :src="item.image" alt="">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
  </div>

</template>
 
<script>
import { statics_pu, statics_channel, friendly_link } from "../../../request/api.user/all"
export default {
  name: '',
  data() {
    return {
      activeName: 'first',
      tabsContent: [
        {
          name: "first",
          label: '贴心健康',
          title: "贴心健康小程序",
          detail: ['全国超百家门店，门店就近无接触配送', '足不出户，轻松购药'],
          qr: require('../../../assets/images/home/qr_tiexin.jpg'),
          path: "intimate",
          pathName: 'intimate',
        },
        {
          name: "second",
          label: '9号云诊',
          title: "9号云诊",
          detail: ['医生一对一问诊，您的私人医生', '图文/视屏，沟通更顺畅'],
          qr: require('../../../assets/images/home/qr_yunzhen.png'),
          path: "diagnosis",
          pathName: 'diagnosis',
        }
      ],
      carousel: [
        {
          title: '贴心健康',
          image: require('../../../assets/images/home/screenshot_tiexin.png')
        },
        {
          title: '9号云诊',
          image: require('../../../assets/images/home/screenshot_yunzhen.png')
        }
      ],
      partner_t: [],
      partner_9: [],


    }
  },
  created() {
    // this.getPartnerT();
    // this.getPartner9();
  },
  mounted() {

  },
  methods: {
    onClick(name) {
      console.log(111)
      this.activeName = name
    },
    getPartnerT() {
      friendly_link({ pageTypeCode: 'INTIMATE_HEALTH', type: '1' }).then(res => {
        // console.log('合作伙伴', res)
        const _this = this;
        if (res.code === 0) {
          this.partner_t = res.data;
        }
      })
    },
    getPartner9() {
      friendly_link({ pageTypeCode: '9HYZ', type: '1' }).then(res => {
        // console.log('合作伙伴', res)
        const _this = this;
        if (res.code === 0) {
          this.partner_9 = res.data;
        }
      })
    },
  }
}
</script>
 
<style  lang="less" rel="stylesheet/less"  scoped>
.home-body {
  background-image: url("../../../assets/images/home/bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center center;
}
.home {
  padding: 20px 0 48px;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  .home-left {
    flex: 1;
    ul {
      display: flex;
      align-items: center;
      li {
        cursor: pointer;
        box-sizing: border-box;
        .name {
          padding: 0 20px 8px;
          font-size: 20px;
          font-weight: bold;
          line-height: 26px;
          color: #333333;
        }
        .line {
          display: flex;
          justify-content: space-between;
          align-items: center;

          span {
            display: inline-block;
            height: 2px;
            background: #cce2ff;
          }
          .left,
          .right {
            width: 50%;
          }
        }
      }
      li.active {
        position: relative;
        margin-bottom: -3px;
        .name {
          color: #124990;
          padding-bottom: 4px;
        }
        .line {
          .left,
          .right {
            height: 2px;
            width: 50%;
            background: #124990;
          }
          .center {
            width: 8px;
            height: 8px;
            background: rgba(18, 73, 144, 1);
            border: 2px solid rgba(255, 255, 255, 1);
            border-radius: 50%;
          }
        }
      }
    }

    .tabs {
      /deep/ .el-tabs__nav-wrap {
        width: 250px;
      }
      /deep/ .el-tabs__item {
        font-size: 20px;
        padding-bottom: 8px;
        color: #333333;
      }
      .tab-content {
        margin-top: 74px;
        display: flex;
        align-items: stretch;
        img {
          width: 205px;
          height: 205px;
        }
        .info {
          margin-left: 30px;
          text-align: left;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          h1 {
            font-size: 40px;
            color: #124990;
            font-weight: bold;
            line-height: 52px;
            // margin-bottom: 14px;
          }
          p {
            color: #6b91c2;
            font-size: 20px;
            font-weight: bold;
            line-height: 40px;
          }
          span {
            display: inline-block;
            // margin-top: 17px;
            width: 160px;
            text-align: center;
            height: 50px;
            line-height: 50px;
            border: 2px solid #e88015;
            border-radius: 4px;
            font-size: 20px;
            color: #e88015;
            box-sizing: border-box;
            cursor: pointer;
          }
        }
      }
    }
  }
  .home-right {
    padding-right: 53px;
    .banner {
      width: 313px;
      height: 556px;
      overflow: hidden;
      /deep/ .el-carousel{
        overflow: hidden;
        .el-carousel__container{
          height: 556px;
        }
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}

/* 友情链接&合作伙伴        */
.friendly-link {
  margin-top: 60px;
  .friendly-title {
    ul {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      li {
        cursor: pointer;
        .name {
          padding: 0 20px 8px;
          font-size: 20px;
          font-weight: bold;
          line-height: 26px;
          color: #333333;
        }
        .line {
          display: flex;
          justify-content: space-between;
          align-items: center;

          span {
            display: inline-block;
            // width: 50%;
            background: #cce2ff;
          }
        }
      }
      li.active {
        .name {
          color: #124990;
        }
        .line {
          .left,
          .right {
            height: 2px;
            width: 50%;
            background: #124990;
          }
          .center {
            width: 8px;
            height: 8px;
            background: rgba(18, 73, 144, 1);
            border: 2px solid rgba(255, 255, 255, 1);
            border-radius: 50%;
          }
        }
      }
    }
  }
  .friendly-content {
    ul {
      margin-top: 33px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      flex-wrap: wrap;
      li {
        margin-bottom: 16px;
        width: 204px;
        height: 72px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      li.block {
        height: 0;
        margin-bottom: 0;
        border: none;
        padding: 0;
      }
    }
  }
}
</style>